var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", [
    _c(
      "div",
      {
        staticClass: "boss-layout-block-large",
        attrs: { id: "message-register" },
      },
      [
        _vm.isWithdraw
          ? [_vm._m(0)]
          : [
              _c("accordion", {
                ref: "register",
                attrs: { "is-open": false },
                scopedSlots: _vm._u([
                  {
                    key: "head",
                    fn: function () {
                      return [_vm._v("メッセージ作成")]
                    },
                    proxy: true,
                  },
                  {
                    key: "body",
                    fn: function () {
                      return [
                        _c("seminar-entry-message-register", {
                          attrs: {
                            "entry-ids": [_vm.entryId],
                            body: _vm.message.body,
                            subject: _vm.message.subject,
                          },
                          on: { registered: _vm.registered },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
            ],
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "boss-layout-block-large" },
      [
        _c("seminar-entry-message-history", {
          ref: "seminarEntryMessageHistory",
          attrs: { "entry-id": _vm.entryId },
          on: { "set-body-and-subject": _vm.setBodyAndSubject },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      {
        staticClass: "boss-annotation-text font-size-1-1em text-center",
        attrs: { "data-test": "withdraw" },
      },
      [
        _c("div", [
          _vm._v(
            "\n          応募後に退会したため、メッセージ送信ができません。\n        "
          ),
        ]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            "\n          レジュメ内のご連絡先に、直接ご連絡ください。\n        "
          ),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }